import { render, staticRenderFns } from "./WaiterRegister.vue?vue&type=template&id=a451fd6c&scoped=true&lang=pug"
import script from "./WaiterRegister.vue?vue&type=script&lang=ts"
export * from "./WaiterRegister.vue?vue&type=script&lang=ts"
import style0 from "./WaiterRegister.vue?vue&type=style&index=0&id=a451fd6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a451fd6c",
  null
  
)

export default component.exports